import React from 'react';

export default function DataDeletion() {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: '40px 20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: 600,
          margin: '0 auto',
          backgroundColor: 'white',
          borderRadius: 16,
          padding: 40,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        }}
      >
        <h1
          style={{
            fontSize: 32,
            fontWeight: 600,
            color: '#1e293b',
            marginBottom: 8,
          }}
        >
          Account Deletion
        </h1>
        <p style={{ fontSize: 16, lineHeight: 1.6, color: '#64748b', marginBottom: 32 }}>
          Request deletion of your authentication account from Berg Regions.
        </p>

        <div
          style={{
            backgroundColor: '#fef3c7',
            borderLeft: '4px solid #f59e0b',
            padding: 16,
            marginBottom: 32,
            borderRadius: 4,
          }}
        >
          <p style={{ fontSize: 14, color: '#92400e', margin: 0, lineHeight: 1.5 }}>
            <strong>Important:</strong> Deleting your account will permanently remove your authentication credentials. This action cannot be undone and you will lose access to all Berg Regions applications.
          </p>
        </div>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            What Will Be Deleted
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginBottom: 12 }}>
            We only store minimal data required for authentication. Deleting your account will remove:
          </p>
          <ul style={{ fontSize: 16, lineHeight: 1.8, color: '#475569', paddingLeft: 20 }}>
            <li>Your email address</li>
            <li>Authentication credentials (password, if applicable)</li>
            <li>Active session tokens</li>
          </ul>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginTop: 12 }}>
            <strong>Note:</strong> We do not store profile information, browsing history, or any other personal data beyond what's necessary for authentication.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            Deletion Timeline
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569' }}>
            Once you contact us with your deletion request, your account will be deleted within <strong>30 days</strong> as required by GDPR and privacy regulations. You will receive a confirmation email once the deletion is complete.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#334155',
              marginBottom: 16,
            }}
          >
            How to Request Deletion
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#475569', marginBottom: 16 }}>
            To delete your account, please send an email to:
          </p>
          <div
            style={{
              backgroundColor: '#f0f9ff',
              border: '2px solid #3b82f6',
              borderRadius: 8,
              padding: 24,
              textAlign: 'center',
              marginBottom: 16,
            }}
          >
            <a
              href="mailto:support@bergregions.pl?subject=Account%20Deletion%20Request"
              style={{
                color: '#3b82f6',
                textDecoration: 'none',
                fontSize: 18,
                fontWeight: 600,
              }}
              onMouseOver={(e) => (e.target.style.color = '#2563eb')}
              onMouseOut={(e) => (e.target.style.color = '#3b82f6')}
            >
              support@bergregions.pl
            </a>
          </div>
          <p style={{ fontSize: 14, lineHeight: 1.6, color: '#64748b' }}>
            Please include your registered email address in your deletion request so we can identify and process your account removal.
          </p>
        </section>

        <div style={{ marginTop: 24 }}>
          <a
            href="/login"
            style={{
              display: 'inline-block',
              color: '#3b82f6',
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500,
            }}
            onMouseOver={(e) => (e.target.style.color = '#2563eb')}
            onMouseOut={(e) => (e.target.style.color = '#3b82f6')}
          >
            ← Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}
